interface State {
  StockList: any[];
  StockProcessTypeList: any[];
  DepartmentList: any[];
  MachineList: any[];
  StockProcessList: any[];
  StockProcessCount: number;
  StockComponentList: any[];
  StockComponentCount: number;
  StockPartList: any[];
  StockPartCount: number;
  BOMList: any[];
  BOMCount: number;
  ProductList: any[];
  ProductCount: number;
}

const initialState: State = {
  StockList: [],
  StockProcessTypeList: [],
  DepartmentList: [],
  MachineList: [],
  StockProcessList: [],
  StockProcessCount: 0,
  StockComponentList: [],
  StockComponentCount: 0,
  StockPartList: [],
  StockPartCount: 0,
  BOMList: [],
  BOMCount: 0,
  ProductList: [],
  ProductCount: 0,
};

export const StockProcessManagerReducer = (
  state: State = initialState,
  action: any,
): State => {
  switch (action.type) {
    case "GET_STOCK_DATA":
      return {
        ...state,
        StockList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.StockList, ...action.payload.data],
      };

    case "GET_STOCK_PROCESS_TYPES_DATA":
      return {
        ...state,
        StockProcessTypeList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.StockProcessTypeList, ...action.payload.data],
      };

    case "GET_DEPARTMENTS_DATA":
      return {
        ...state,
        DepartmentList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.DepartmentList, ...action.payload.data],
      };

    case "GET_MACHINES_DATA":
      return {
        ...state,
        MachineList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.MachineList, ...action.payload.data],
      };

    case "GET_STOCK_PROCESSES_DATA":
      return {
        ...state,
        StockProcessList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.StockProcessList, ...action.payload.data],
        StockProcessCount: action.payload.count,
      };

    case "GET_STOCK_COMPONENTS_DATA":
      return {
        ...state,
        StockComponentList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.StockComponentList, ...action.payload.data],
        StockComponentCount: action.payload.count,
      };

    case "GET_STOCK_PARTS_DATA":
      return {
        ...state,
        StockPartList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.StockPartList, ...action.payload.data],
        StockPartCount: action.payload.count,
      };

    case "GET_BOM_DATA":
      return {
        ...state,
        BOMList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.BOMList, ...action.payload.data],
        BOMCount: action.payload.count,
      };

    case "UPDATE_BOM_ITEM":
      return {
        ...state,
        BOMList: state.BOMList.map((item) =>
          item._id === action.payload._id ? { ...item, ...action.payload } : item
        ),
      };

    case "GET_PRODUCT_LIST_DATA":
      return {
        ...state,
        ProductList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.ProductList, ...action.payload.data],
        ProductCount: action.payload.count,
      };

    case "CLEAR_STOCK_PROCESS_MANAGER_DATA":
      return {
        ...state,
        StockList: [],
        StockProcessTypeList: [],
        DepartmentList: [],
        MachineList: [],
        StockProcessList: [],
        StockProcessCount: 0,
        StockComponentList: [],
        StockComponentCount: 0,
        StockPartList: [],
        StockPartCount: 0,
        BOMList: [],
        BOMCount: 0,
        ProductList: [],
        ProductCount: 0,
      };

    default:
      return state;
  }
};
